'use strict';

angular.module('atex.aceui.service').factory('UserDataService',
['$q', '$rootScope', 'AuthenticationService', 'ContentService', 'ApplicationConfigurationService',

  function($q, $rootScope, AuthenticationService, ContentService, ApplicationConfigurationService) {
    var serviceHandler = undefined;

    var handler = function() {
      if (serviceHandler !== undefined) {
        return $q.when(serviceHandler);
      }

      return ApplicationConfigurationService.getServiceConfigurationFor('UserDataService').then(function(configuration) {
        var serviceUrl = atex.aceui.ServiceUtils.calculateServiceUrl(configuration, 'user');

        var serviceSettings = { customQ: atex.aceui.AngularUtils.applyingQ($q, $rootScope), cacheBusting: atex.aceui.BrowserUtils.isSafariBrowser() };
        serviceHandler = atex.aceui.service.UserDataService(serviceUrl, serviceSettings);

        return serviceHandler;
      });
    };

    return {
      /**
       * Retrieves the user data for the user represented by the given login name.
       * Wraps the request with an authentication guard.
       *
       * @param {string} loginName - the login name of the user to fetch the user data for
       *
       * @typedef {Object} UserData - the user data object as returned from the server
       *
       * @typedef {Object} UserDataResult - an object containing the result of the user data request
       * @property {UserData} userData - the user data result of the user data request
       *
       * @see atex.aceui.service.UserDataService
       * @see AuthenticationService
       *
       * @returns {Promise.<UserDataResult, atex.aceui.error.Error>}
       */
      getUserData: function(loginName) {
        return AuthenticationService.callWithAuthentication(function(currentUser) {
          return handler().then(function(serviceHandler) {
            return serviceHandler.getUserData({ loginName: loginName, authToken: currentUser.token });
          });
        });
      },

      /**
       * Retrieves the user contexts for the user represented by the given login name. Defaults to
       * fetching user contexts for currently logged in user if loginName is not supplied.
       *
       * @param {string} loginName - the login name of the user to fetch the user contexts for.
       *
       * @typedef {Object} UserContexts - a list of user contexts for the given user
       *
       * @see atex.aceui.service.UserDataService
       * @see AuthenticationService
       *
       * @returns {Promise.<UserContexts, atex.aceui.error.Error>}
       */
      getUserContexts: (loginName) => {
        return AuthenticationService.getCurrentUser()
          .then(currentUser => {
            return ContentService.getContent({ alias: '_userdata/' + (loginName || currentUser.userId) })
          })
          .then(contentResponse => {
            return atex.aceui.ObjectUtils.getByPath(contentResponse, 'content/aspects/aceUserContext/contexts') || [];
          })
          .catch(error => {
            if (typeof error.type !== 'undefined' || error.type !== atex.aceui.error.types.NOT_FOUND) {
              return [];
            }

            throw error;
          });
      }
    };
  }
]);
